import { render, staticRenderFns } from "./NotificationsRecordsDetails.vue?vue&type=template&id=4c93b4ec&"
import script from "./NotificationsRecordsDetails.vue?vue&type=script&lang=js&"
export * from "./NotificationsRecordsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports